import React from "react"
import PropTypes from "prop-types"
import { StepIcon, StepLine } from "../reservation-styled"
import {
  indicatorLine,
  stepWrapper,
  stepIcon,
  stepIndicator,
  visuallyHidden,
} from "./step-indicator.module.scss"

export const StepIndicator = ({ step, refs }) => {
  return (
    <section className={stepIndicator}>
      <div className={stepWrapper} aria-hidden={step !== 2}>
        <StepIcon
          active={step === 2}
          isDone={step > 2}
          className={stepIcon}
          tabIndex={step === 2 ? 0 : -1}
          ref={refs.current[2]}
        >
          <p className={visuallyHidden}>Étape</p>1
          <p className={visuallyHidden}>sur 4 en cours</p>
        </StepIcon>
      </div>
      <StepLine
        active={step === 3}
        isDone={step > 2}
        className={indicatorLine}
      ></StepLine>
      <div className={stepWrapper} aria-hidden={step !== 3}>
        <StepIcon
          active={step === 3}
          isDone={step > 3}
          className={stepIcon}
          tabIndex={step === 3 ? 0 : -1}
          ref={refs.current[3]}
        >
          <p className={visuallyHidden}>Étape</p>2
          <p className={visuallyHidden}>sur 4 en cours</p>
        </StepIcon>
      </div>
      <StepLine
        active={step === 4}
        isDone={step > 3}
        className={indicatorLine}
      ></StepLine>
      <div className={stepWrapper} aria-hidden={step !== 4}>
        <StepIcon
          active={step === 4}
          isDone={step > 4}
          className={stepIcon}
          tabIndex={step === 4 ? 0 : -1}
          ref={refs.current[4]}
        >
          <p className={visuallyHidden}>Étape</p>3
          <p className={visuallyHidden}>sur 4 en cours</p>
        </StepIcon>
      </div>
    </section>
  )
}

StepIndicator.propTypes = {
  step: PropTypes.number,
  refs: PropTypes.arrayOf(PropTypes.shape({ current: PropTypes.any })),
}
